import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { ResPrice } from '@/lib/queries/business/pricing/types'

export const getPricingQuery = queryOptions({
  queryKey: ['pricing'],
  queryFn: (): Promise<ResPrice[]> => w.get('/business/pricing').json(),
})
